import { AdSizes, adSizes } from '../../components/presentational/Ad';

const {
  fluid,
  mediumRectangle,
  halfPage,
  largeRectangle,
  leaderboard,
  mediumBillboard,
  largeLeaderboard,
  billboard,
} = adSizes;

const config: AdSizes = {
  sticky: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [halfPage, mediumRectangle],
      },
    ],
  },
  top: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [fluid, mediumRectangle],
      },
      {
        viewport: [largeRectangle[0], 0],
        slot: [fluid, largeRectangle, mediumRectangle],
      },
      {
        viewport: [leaderboard[0], 0],
        slot: [fluid, mediumBillboard, leaderboard],
      },
      {
        viewport: [billboard[0], 0],
        slot: [fluid, billboard, largeLeaderboard],
      },
    ],
  },
  bottom: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [fluid, mediumRectangle],
      },
      {
        viewport: [largeRectangle[0], 0],
        slot: [fluid, largeRectangle, mediumRectangle],
      },
      {
        viewport: [leaderboard[0], 0],
        slot: [fluid, mediumBillboard, leaderboard],
      },
      {
        viewport: [billboard[0], 0],
        slot: [fluid, billboard, largeLeaderboard],
      },
    ],
  },
};

export default config;
